<template>
  <div>
    <v-layout justify-end align-content-end align-end>
      <v-btn outline color="primary" :loading="loading" @click="exportRankingReport()">{{
        $t('export')
      }}</v-btn>
    </v-layout>
    <DateFilter
      v-model="selectedDate"
      class="mt-3"
      :default-filter="'today'"
      @changeDate="reCallData()"
    ></DateFilter>
    <v-card style="padding: 16px" class="mt-3">
      <v-layout row wrap>
        <v-flex xs12>
          <h2 style="color: #777">{{ $t('total_of', [$t('reporting').toLowerCase()]) }}</h2>
        </v-flex>
        <v-flex xs12>
          <h1 style="text-align: end">{{ totalReports }}</h1>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout class="mt-5" row wrap>
      <v-flex xs12>
        <h1>{{ $t('reporting') }}</h1>
      </v-flex>
      <v-flex xs12 class="mt-3">
        <v-card>
          <v-data-table :loading="loading" hide-actions :headers="headers" :items="rankingData">
            <template #items="props">
              <td>
                <div class="d-inline-block" :style="{ position: 'relative' }">
                  {{ props.index + 1 }}
                  <img
                    v-if="props.index >= 0 && props.index < 3"
                    :src="`/static/img/assets/shop/crown${props.index + 1}.png`"
                    :style="{
                      position: 'absolute',
                      width: '24px',
                      top: '-100%',
                      left: '50%',
                      transform: 'translateX(-50%)'
                    }"
                  />
                </div>
              </td>
              <td>{{ props.item.topic }}</td>
              <td>{{ props.item.total_reports }}</td>
              <td>
                {{
                  props.item.percent_total_reports
                    ? parseFloat(props.item.percent_total_reports).toFixed(2)
                    : '0'
                }}%
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import tigerpolyApi from '../../../../../api/tigerpoly'
import XLSX from 'xlsx'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      rankingData: [],
      totalAllReports: 0,
      headers: [
        { text: this.$t('no.'), value: '', sortable: false },
        { text: this.$t('reporting_name'), value: 'topic', sortable: false },
        { text: this.$t('amount'), value: 'total_reports', sortable: false },
        { text: '', value: 'percent_total_reports', sortable: false }
      ]
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    totalReports() {
      return this.rankingData.reduce((prev, item) => prev + +item.total_reports, 0)
    }
  },
  methods: {
    async init() {
      this.reCallData()
    },
    async reCallData() {
      const { data, total_all_reports } = await this.fetchRankingReport()
      if (total_all_reports) {
        this.totalAllReports = total_all_reports
      }
      if (data) {
        this.rankingData = data
      }
    },
    async fetchRankingReport() {
      try {
        this.loading = true
        const config = {
          params: {
            page_id: this.selectedBot.pageid,
            datefrom: this.selectedDate.start,
            dateto: this.selectedDate.end
          }
        }
        const response = await tigerpolyApi.getRankingReport(config)
        return response.data
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          text: 'เรียกข้อมูลไม่สำเร็จ',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    exportRankingReport() {
      const filename = 'ranking_report'
      const rows = []
      rows.push(['Ranking Report', '', '', ''])
      rows.push([
        `Filter Date From ${moment(this.selectedDate.start).format('DD/MM/YYYY')} - ${moment(
          this.selectedDate.end
        ).format('DD/MM/YYYY')}`,
        '',
        '',
        ''
      ])
      rows.push(['', '', '', ''])
      rows.push(['No.', 'Reporting Name', 'Amount', 'Amount(percent)'])
      for (let i = 0; i < this.rankingData.length; i++) {
        const data = this.rankingData[i]
        rows.push([
          i + 1,
          data.topic,
          data.total_reports,
          data.percent_total_reports ? parseFloat(data.percent_total_reports).toFixed(2) : '0'
        ])
      }
      rows.push(['', '', '', ''])
      rows.push(['Total Reporting', this.totalReports, '', ''])
      const wb = XLSX.utils.book_new()
      const dataWS = XLSX.utils.aoa_to_sheet(rows)
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, `${filename}.xlsx`)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/RankingReport.vue